import React from 'react';
import { ActionButtonGroup, PauseBillingDetailsFooter } from '../../../shared';
import { useBillingActions, useFlowActions } from '../../../../context';

/**
 * Component that displays the pause offer for users who select "tooBusy" as their reason
 * Offers a 30-day billing pause with continued access
 */
const PauseOffer = () => {
  // Get actions from context
  const { pause } = useBillingActions();
  const { cancelAnyway } = useFlowActions();

  return (
    <div className="pause-offer-content">
      <div className="mb-4">
        <h5 className="mb-3">Thanks for letting us know that you're busy. We get it!</h5>
        <p className="mb-3">And we want to help you keep making your health a priority.</p>
        <p className="mb-3">
          So instead of canceling, we'd like to invite you to <strong>pause your billing for 30 days</strong> and still
          keep full access to your WHOLE Life Club membership. (That means a free month, on us.)
        </p>
        <p className="mb-4">
          During your billing pause, we'll share a few quick tips and 10-minute wins to help you use WLC in ways that
          fit your schedule. That way, when you're ready, it will feel easier than ever to jump back in - on your terms.
        </p>

        <ActionButtonGroup
          primaryAction={{
            text: 'Pause My Billing (Keep My Access)',
            onClick: pause,
            color: 'primary',
            className: 'mb-3'
          }}
          secondaryAction={{
            text: 'Cancel Anyway',
            onClick: cancelAnyway
          }}
          layout="vertical"
        />

        <PauseBillingDetailsFooter className="pause-details mb-3" />
      </div>
    </div>
  );
};

export default PauseOffer;
